/* eslint-disable camelcase */
import Cookies from 'js-cookie';
import { vueLocalStorage } from './vueLocalStroge';
const TokenKey = 'giikin_chatgpt';

export function getToken() {
  const ssoToken = Cookies.get('token');
  if (ssoToken) {
    return {
      _token: ssoToken,
    };
  }

  return {};
}

export function setToken(token: string) {
  return vueLocalStorage.setItem(TokenKey, token);
}

export function removeToken() {
  return vueLocalStorage.removeItem(TokenKey);
}
